import React, { useEffect, useMemo } from "react";
// import { Stimulsoft } from '../../../../_metronic/_assets/stimulsoft/stimulsoft.viewer';
// import '../../../../_metronic/_assets/stimulsoft/stimulsoft.viewer.office2013.whiteblue.css';
import { useDispatch } from "react-redux";
import { toAbsoluteUrl } from '../../../../_metronic/_helpers';
import * as actions from "../../../../app/actions/generalActions";
import { useFilterObjectsUIContext } from "../../../../_metronic/layout/components/basePage/pages/FilterObjectsUIContext";
import { useObjectsUIContext } from "../../../../_metronic/layout/components/basePage/pages/ObjectsUIContext";
import { shallowEqual, useSelector } from "react-redux";
import moment from "moment-jalaali";



export const StimulSoftViewer = () => {


  const dispatch = useDispatch();

  // useEffect(() => {
  //   const query = {
  //     whereClause: "",
  //     whereClauseParameters: [],
  //     orderClause: "id asc ",
  //     skipCount: 0,
  //     takeCount: 1000,
  //     filter: {
  //       // title: "",
  //     },
  //   };
  //   dispatch(actions.fetchObjects(api, currentState.name, query, getFunctionName));

  // }, []);

  const user = useSelector((state) => state.auth.user, shallowEqual);
  const entities = JSON.parse(sessionStorage.stimulReport);
  const mrtUrl = JSON.parse(sessionStorage.mrtUrl);
  const jsonFileName = JSON.parse(sessionStorage.jsonFileName);
  // const fontUrl =  toAbsoluteUrl('/_metronic/_assets/fonts/IRANSans-Light-web-fa.ttf')

  useEffect(() => {
    if (entities) {
      console.log('Loading Viewer view - font url');
      // console.log(fontUrl);
      // var dir = require('./assets/_assets/fonts/IRANSans-Light-web-fa.ttf');
      //  console.log(dir);
      var options = new window.Stimulsoft.Viewer.StiViewerOptions();
      options.appearance.htmlRenderMode = window.Stimulsoft.Report.Export.StiHtmlExportMode.Table;
      // options.Base.StiFontCollection.addOpentypeFontFile('https://fonts.googleapis.com/css2?family=Hanalei+Fill&display=swap');    
      // options.appearance.allowChangeWindowTitle = false;
      // options.toolbar.fontFamily = 'SANS';
      // options.appearance.fontFamily = 'SANS';

      options.appearance.rightToLeft = true;
      // options.appearance.pageAlignment = window.Stimulsoft.Viewer.StiContentAlignment.Right;
      options.toolbar.alignment = window.Stimulsoft.Viewer.StiContentAlignment.rightToLeft;
      options.toolbar.showPrintButton = false;
      options.toolbar.viewMode = window.Stimulsoft.Viewer.StiWebViewMode.Continuous;
      // options.Data ='SANS';


      // options.toolbar.backgroundColor = window.Stimulsoft.System.Drawing.Color.aqua;
      // options.toolbar.borderColor = window.Stimulsoft.System.Drawing.Color.darkGreen;
      // options.toolbar.fontColor = window.Stimulsoft.System.Drawing.Color.white;

      options.toolbar.showAboutButton = false;
      options.toolbar.showBookmarksButton = false;
      options.toolbar.showParametersButton = false;
      // options.toolbar.showFullScreenButton = false;
      options.toolbar.showOpenButton = false;
      // options.report.alignment = window.Stimulsoft.report.rightToLeft.rightToLeft;

      // options.height = "100%";
      //options.appearance.showTooltips = false;

      console.log('Creating the report viewer with default options');
      console.log(options);
      var viewer = new window.Stimulsoft.Viewer.StiViewer(options, 'StiViewer', false);
      console.log('Creating a new report instance');
      var report = new window.Stimulsoft.Report.StiReport();

      var data = { data_1: entities }
      if (mrtUrl === "/reports/FormResultReports.mrt") {
        var temp = []
        var idx = 1
        entities.forEach(element => {
          element.answers.forEach(answer => {
            answer.provinceTitle = element.provinceTitle
            answer.townTitle = element.title
            answer.townId = element.code
            answer.rowIndex = idx++
            temp.push(answer)
          });

          temp.push({
            provinceTitle: "",
            townTitle: "",
            townId: "",
            rowIndex: "",
            questionTitle: "",
            answerOfQuestionTitle: "",
          })
        });

        data = {}
        data = { data_1: temp }
      }

      if (mrtUrl === "/reports/ProvienceFormResultReports.mrt") {
        var temp = []
        var idx = 1
        entities.forEach(element => {
          element.answers.forEach(answer => {
            answer.provinceTitle = element.title
            answer.rowIndex = idx++
            temp.push(answer)
          });

          temp.push({
            provinceTitle: "",
            townTitle: "",
            townId: "",
            rowIndex: "",
            questionTitle: "",
            answerOfQuestionTitle: "",
          })
        });

        data = {}
        data = { data_1: temp }
      }

      var dataSet = new window.Stimulsoft.System.Data.DataSet("Report");
      dataSet.readJson(JSON.stringify(data));//one JSON object
      //this line of code added,too.
      report.dictionary.databases.clear();
      report.regData(jsonFileName, jsonFileName, dataSet);
      //this line of code is also required.
      report.dictionary.synchronize();
      report.loadFile(mrtUrl);

      // report.renderAsync(function () {
      //   document.write("Complete.<br>");
      //   document.write("Rendered pages count: " + report.renderedPages.count);
      // }); roleId ProvienceBlockReports.mrt
      var rpt = user.placeTitle ? user.placeTitle : "";

      if (user.roleId.toString().endsWith("00") || user.roleId < 10 || user.roleId === 508014) {
        if (mrtUrl.endsWith("CountryBlockReports.mrt") || mrtUrl.endsWith("CountryFormResultReports.mrt"))
          rpt = "کشوری"

        if (mrtUrl.endsWith("ProvienceBlockReports.mrt") || mrtUrl.endsWith("ProvienceFormResultReports.mrt"))
          rpt = "استانی"

        if (mrtUrl.endsWith("PlaceBlockReports.mrt") || mrtUrl.endsWith("FormResultReports.mrt"))
          rpt = "پردیس / مرکز"
      }


      report.dictionary.variables.getByName(
        "repTitle"
      ).valueObject = rpt;

      report.dictionary.variables.getByName(
        "repSemat"
      ).valueObject = user.semat;

      report.dictionary.variables.getByName(
        "repDate"
      ).valueObject = moment().locale('fa').format('jYYYY/jM/jD');

      report.dictionary.variables.getByName(
        "operFullName"
      ).valueObject = user.firstName + " " + user.lastName;

      report.dictionary.variables.getByName(
        "placeTitle"
      ).valueObject = user.placeTitle ? user.placeTitle : "";

      viewer.report = report;

      viewer.renderHtml("viewer");


      // console.log('Load report from url');
      // report.loadFile(mrtUrl);

      // console.log('Assigning report to the viewer, the report will be built automatically after rendering the viewer');
      // viewer.report = report;

      // console.log('Rendering the viewer to selected element');
      // viewer.renderHtml('viewer');
    }
  }, [entities])

  return (
    <div id="viewer" style={{ fontFamily: 'tahoma,SANS,Poppins,Helvetica,"sans-serif"' }, { direction: 'ltr' }}></div>
  );
};
